import { Text } from '@mantine/core'
import type { OrpcClient } from '@/orpc/client'
import type { AccountingReport } from '@/model/middleware-types'
import { formatCalendarDate, formatCents } from '../utils'

export type ReportResult = Awaited<ReturnType<OrpcClient['billingV2Report']>>

export function SummaryCards({
  cards,
  asOf,
  activeReport,
  onSelect,
}: {
  cards: ReportResult['cards']
  asOf: string
  activeReport: AccountingReport
  onSelect: (report: AccountingReport, label: string) => void
}) {
  const through = formatCalendarDate(asOf)
  const adjustmentsCents = cards.totalChargesCents - cards.chargesAfterAdjustmentsCents

  const items: { label: string; caption: string; cents: number; report: AccountingReport }[] = [
    {
      label: 'Total charges',
      caption: 'Service dates in selected range',
      cents: cards.totalChargesCents,
      report: 'revenue',
    },
    {
      label: 'Charges after adjustments',
      caption: `After ${formatCents(adjustmentsCents)} in adjustments & write-offs`,
      cents: cards.chargesAfterAdjustmentsCents,
      report: 'revenue',
    },
    {
      label: 'Payments for selected visits',
      caption: `Selected visits · net payments through ${through}`,
      cents: cards.paymentsCents,
      report: 'payments',
    },
    {
      label: 'Outstanding balance',
      caption: `Selected visits · as of ${through}`,
      cents: cards.outstandingCents,
      report: 'outstanding',
    },
  ]

  return (
    <div className="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-4">
      {items.map((item) => (
        <button
          key={item.label}
          type="button"
          aria-pressed={item.report === activeReport}
          onClick={() => onSelect(item.report, item.label)}
          className={`cursor-pointer rounded-md border bg-white p-4 text-left shadow-sm ${
            item.report === activeReport ? 'border-blue-500' : 'border-slate-200'
          }`}
        >
          <Text size="sm" c="dimmed">
            {item.label}
          </Text>
          <Text size="xl" fw={700}>
            {formatCents(item.cents)}
          </Text>
          <Text size="xs" c="dimmed">
            {item.caption}
          </Text>
        </button>
      ))}
    </div>
  )
}
